{
  "metadata": {
    "id": "ayu-light",
    "name": "Ayu",
    "description": "Портировано из темы «Ayu» (light)",
    "author": "OpenCode",
    "version": "2.0.0",
    "variant": "light",
    "tags": [
      "light",
      "ported"
    ],
    "source": {
      "file": "ayu.json",
      "project": "ayu-theme",
      "url": "https://github.com/ayu-theme/ayu-vim",
      "upstreamFile": "packages/ui/src/theme/themes/ayu.json",
      "license": "Apache-2.0",
      "authoring": null
    },
    "validation": {
      "checks": 34,
      "fails": [],
      "paletteMinDeltaE": 28.8,
      "paletteTarget": 20.0,
      "paletteFloor": 18.0,
      "paletteAvgS": 0.446,
      "paletteMaxS": 0.537,
      "paletteAcid": 0,
      "surfacesMinDeltaE": 8.0,
      "surfacesTarget": 8.0,
      "surfacesRaisedTarget": 10.0,
      "surfacesAway": false,
      "syntaxMinDeltaE": 20.3,
      "syntaxVsTextMinDeltaE": 2.3,
      "chartsMinDeltaE": 45.9,
      "textSeparationDeltaE": 10.1,
      "textSeparationTarget": 10.0,
      "textSeparationFloor": 8.0,
      "textSeparationTinted": false,
      "authorialCollisions": [
        {
          "a": "function",
          "b": "type",
          "deltaE": 10.3
        }
      ],
      "modeLabel": "light",
      "modeFromLuminance": "light",
      "paletteIdenticalToPeer": false
    }
  },
  "colors": {
    "primary": {
      "base": "#399abb",
      "hover": "#338ba8",
      "active": "#2f7e99",
      "foreground": "#000000",
      "muted": "#399abb80",
      "emphasis": "#399abb"
    },
    "surface": {
      "background": "#fdfaf4",
      "foreground": "#2e333a",
      "muted": "#cccdcc",
      "mutedForeground": "#45494c",
      "elevated": "#b4b7b9",
      "elevatedForeground": "#3f4750",
      "raised": "#989ca1",
      "raisedForeground": "#2d3339",
      "overlay": "#fdfaf433",
      "subtle": "#e4e3e0"
    },
    "interactive": {
      "border": "#8f959a",
      "borderHover": "#c7c8c7",
      "borderFocus": "#399abb",
      "selection": "#4f596424",
      "selectionForeground": "#4f5964",
      "focus": "#399abb59",
      "focusRing": "#399abb47",
      "cursor": "#4f5964",
      "hover": "#4f596417",
      "active": "#4f596424"
    },
    "status": {
      "error": "#dc282f",
      "errorForeground": "#ffffff",
      "errorBackground": "#dc282f1a",
      "errorBorder": "#dc282f59",
      "warning": "#a46312",
      "warningForeground": "#ffffff",
      "warningBackground": "#a463121a",
      "warningBorder": "#a4631259",
      "success": "#387f4c",
      "successForeground": "#ffffff",
      "successBackground": "#387f4c1a",
      "successBorder": "#387f4c59",
      "info": "#2579a0",
      "infoForeground": "#ffffff",
      "infoBackground": "#2579a01a",
      "infoBorder": "#2579a059"
    },
    "pr": {
      "open": "#387f4c",
      "draft": "#52565b",
      "blocked": "#a46312",
      "merged": "#ec685a",
      "closed": "#dc282f"
    },
    "syntax": {
      "base": {
        "background": "#cccdcc",
        "foreground": "#4f5964",
        "comment": "#525860",
        "keyword": "#834611",
        "string": "#475c00",
        "number": "#703ea2",
        "function": "#205c7e",
        "variable": "#4d5661",
        "type": "#185a88",
        "operator": "#0c0d0d"
      },
      "tokens": {
        "commentDoc": "#525860",
        "stringEscape": "#0c0d0d",
        "keywordImport": "#834611",
        "storageModifier": "#834611",
        "functionCall": "#205c7e",
        "method": "#205c7e",
        "variableProperty": "#205c7e",
        "variableOther": "#4d5661",
        "variableGlobal": "#703ea2",
        "variableLocal": "#0c0d0d",
        "parameter": "#4d5661",
        "constant": "#703ea2",
        "class": "#185a88",
        "className": "#185a88",
        "interface": "#185a88",
        "struct": "#185a88",
        "enum": "#185a88",
        "typeParameter": "#185a88",
        "namespace": "#185a88",
        "module": "#834611",
        "tag": "#834611",
        "jsxTag": "#834611",
        "tagAttribute": "#205c7e",
        "tagAttributeValue": "#475c00",
        "boolean": "#703ea2",
        "decorator": "#834611",
        "label": "#205c7e",
        "regexp": "#475c00"
      }
    },
    "charts": {
      "series": [
        "#399abb",
        "#2550a0",
        "#387f4c",
        "#a46312",
        "#dc282f"
      ]
    },
    "chat": {
      "background": "#fdfaf4",
      "userMessage": "#3f4750",
      "userMessageBackground": "#b4b7b9",
      "assistantMessage": "#4d5661",
      "assistantMessageBackground": "#cccdcc",
      "timestamp": "#52565b",
      "divider": "#8f959a",
      "typing": "#52565b"
    },
    "loading": {
      "spinner": "#399abb",
      "spinnerTrack": "#cccdcc",
      "skeleton": "#cccdcc",
      "shimmer": "#c4c6c6"
    },
    "tools": {
      "background": "#cccdcc",
      "border": "#8f959a",
      "headerHover": "#c6c7c7",
      "icon": "#2d7a94",
      "title": "#4f5964",
      "description": "#52565b",
      "edit": {
        "added": "#387f4c",
        "addedBackground": "#387f4c1a",
        "removed": "#dc282f",
        "removedBackground": "#dc282f1a",
        "modified": "#2579a0",
        "modifiedBackground": "#2579a01a",
        "lineNumber": "#52565b"
      }
    },
    "markdown": {
      "heading1": "#4f5964",
      "heading2": "#4f5964",
      "heading3": "#4f5964",
      "heading4": "#4f5964",
      "link": "#2d7a94",
      "linkHover": "#2d7b94",
      "inlineCode": "#475c00",
      "inlineCodeBackground": "#cccdcc",
      "blockquote": "#52565b",
      "blockquoteBorder": "#8f959a",
      "listMarker": "#3897b7",
      "bold": "#4f5964",
      "italic": "#4f5964e6",
      "strikethrough": "#52565b",
      "hr": "#8f959a"
    }
  },
  "palette": {
    "version": 1,
    "colors": [
      {
        "key": "a1",
        "name": "Красный",
        "hex": "#cf9499",
        "foreground": "#000000",
        "contrast": 8.35
      },
      {
        "key": "a2",
        "name": "Лососевый",
        "hex": "#b76341",
        "foreground": "#000000",
        "contrast": 4.87
      },
      {
        "key": "a3",
        "name": "Янтарный",
        "hex": "#8a7642",
        "foreground": "#000000",
        "contrast": 4.75
      },
      {
        "key": "a4",
        "name": "Салатовый",
        "hex": "#dedc94",
        "foreground": "#000000",
        "contrast": 14.77
      },
      {
        "key": "a5",
        "name": "Лаймовый",
        "hex": "#75973f",
        "foreground": "#000000",
        "contrast": 6.25
      },
      {
        "key": "a6",
        "name": "Светло-зелёный",
        "hex": "#50bc4c",
        "foreground": "#000000",
        "contrast": 8.64
      },
      {
        "key": "a7",
        "name": "Зелёный",
        "hex": "#92dca2",
        "foreground": "#000000",
        "contrast": 12.98
      },
      {
        "key": "a8",
        "name": "Мятный",
        "hex": "#448a67",
        "foreground": "#000000",
        "contrast": 5.08
      },
      {
        "key": "a9",
        "name": "Бирюзовый",
        "hex": "#93dbdc",
        "foreground": "#000000",
        "contrast": 13.41
      },
      {
        "key": "a10",
        "name": "Голубой",
        "hex": "#417788",
        "foreground": "#ffffff",
        "contrast": 4.98
      },
      {
        "key": "a11",
        "name": "Синий",
        "hex": "#31568f",
        "foreground": "#ffffff",
        "contrast": 7.35
      },
      {
        "key": "a12",
        "name": "Васильковый",
        "hex": "#353db0",
        "foreground": "#ffffff",
        "contrast": 8.59
      },
      {
        "key": "a13",
        "name": "Фиолетовый",
        "hex": "#aa93cd",
        "foreground": "#000000",
        "contrast": 7.76
      },
      {
        "key": "a14",
        "name": "Орхидея",
        "hex": "#a243b5",
        "foreground": "#ffffff",
        "contrast": 5.24
      },
      {
        "key": "a15",
        "name": "Пурпурный",
        "hex": "#cb67a6",
        "foreground": "#000000",
        "contrast": 6.03
      },
      {
        "key": "a16",
        "name": "Розовый",
        "hex": "#91344c",
        "foreground": "#ffffff",
        "contrast": 7.5
      }
    ]
  }
}
